<div class="modal-header bg-soft-info p-3">
    <h5 *ngIf='inviteType == 1' class="modal-title" id="exampleModalLabel" i18n="@@">Invite Client</h5>
    <h5 *ngIf='inviteType == 0' class="modal-title" id="exampleModalLabel" i18n="@@">Invite User</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>
<div class="card-body p-3">
    <div class="col-lg-12">
        <div class="mb-3">
            <label i18n="@@">Name</label>
            <input required #firstName="ngModel" mask='A* A* A* A* A* A*' [dropSpecialCharacters]="false"
                [ngClass]="{ 'is-invalid': (firstName.invalid && ((firstName.dirty || firstName.touched) || submitted == true))}"
                class="form-control" type="text" placeholder="Enter Name" i18n-placeholder="@@"
                [(ngModel)]="model.firstName" (keypress)="modalEdited = true" />
            <div *ngIf="(firstName.invalid && ((firstName.dirty || firstName.touched) || submitted == true))"
                class='invalidInputTextMessage'>
                <div *ngIf="firstName.errors?.['required']">
                    <div i18n="@@"> Name is Required</div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-lg-12 mb-3">
        <label i18n="@@">Email</label>
        <input class="form-control" type="text" required [pattern]="emailPattern" #email="ngModel"
            [ngClass]="{ 'is-invalid': (email.invalid && ((email.dirty || email.touched) || submitted == true))}"
            placeholder="Enter Email" i18n-placeholder="@@" [(ngModel)]="model.email" (keypress)="modalEdited = true" />
        <div *ngIf="(email.invalid && ((email.dirty || email.touched) || submitted == true))"
            class='invalidInputTextMessage'>
            <div *ngIf="email.errors?.['required'] else elseEmail">
                <div i18n="@@">Email is Required</div>
            </div>
            <ng-template #elseEmail>
                <div *ngIf="email.invalid">
                    <div i18n="@@">Email Invalid</div>
                </div>
            </ng-template>
        </div>
    </div>
    <div class="col-lg-12 mb-3" *ngIf='inviteType == 0 && rolesList.length > 0'>
        <label for="jobtitle-field" class="form-label" i18n="">Roles</label>
        <div class="form-control" style="padding: 0%; ">
            <div class="d-flex align-items -center form-control " style="padding: 0%; border-width: 0px;">
                <ng-select style="flex-grow: 1; " [items]="rolesList" [multiple]="true" bindLabel="name"
                    [(ngModel)]="selectedRolesArray" placeholder="Roles">
                    <ng-template ng-optgroup-tmp let-item="item" style="display: flex;">
                        {{item}}
                    </ng-template>
                </ng-select>
            </div>
        </div>
    </div>
    <div class="hstack d-flex justify-content-end">
        <button [disabled]=submitted type="button" class="btn btn-success " id="add-btn" (click)="sendEmail()"
            i18n="@@">Send Email Invite</button>
    </div>

</div>